import { ProductName } from './enums';

export interface ProductSettings {
	id: string;
	name: string;
	icon: ProductIconSettings;
	hasPermissions: boolean;
}

interface ProductIconSettings {
	initials: string;
	color: string;
	textColor: string;
}

export const productMap: ProductSettings[] = [
	{
		id: `${process.env.REACT_APP_MATCH_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.Match,
		hasPermissions: false,
		icon: {
			initials: 'GO',
			color: 'bgSuccess',
			textColor: 'textOnLight',
		},
	},
	{
		id: `${process.env.REACT_APP_NEWS_PAGE_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.NewsPage,
		hasPermissions: true,
		icon: {
			initials: 'NE',
			color: 'bgWarning',
			textColor: 'textOnLight',
		},
	},
	{
		id: `${process.env.REACT_APP_ALERTS_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.Alerts,
		hasPermissions: false,
		icon: {
			initials: 'AL',
			color: 'bgSell',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_ENAPPSYS_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.EnAppSys,
		hasPermissions: false,
		icon: {
			initials: 'EN',
			color: 'bgBrand',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_FLEXINSIGHT_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.FlexInsight,
		hasPermissions: true,
		icon: {
			initials: 'FI',
			color: 'bgBrand',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_EQ_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.EnergyQuantified,
		hasPermissions: false,
		icon: {
			initials: 'EQ',
			color: 'bgInfo',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_MARKETS_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.MontelMarkets,
		hasPermissions: true,
		icon: {
			initials: 'MM',
			color: 'borderGraphicsPurple',
			textColor: 'textOnLight',
		},
	},
	{
		id: `${process.env.REACT_APP_MONTEL_ONLINE_APPLICATION_ID?.toLowerCase()}`,
		name: 'Montel Online',
		hasPermissions: false,
		icon: {
			initials: 'MO',
			color: 'bgBuy',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_SYSPOWER_APPLICATION_ID?.toLowerCase()}`,
		name: 'SysPower',
		hasPermissions: false,
		icon: {
			initials: 'SP',
			color: 'bgDataUp',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_POWER_PLANT_API_APPLICATION_ID?.toLowerCase()}`,
		name: 'Power Plant API',
		hasPermissions: false,
		icon: {
			initials: 'PP',
			color: 'bgInfo',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_DATA_FABRICATOR_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.DataFabricator,
		hasPermissions: true,
		icon: {
			initials: 'DF',
			color: 'bgInfo',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_MONTEL_PPA_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.MontelPPA,
		hasPermissions: false,
		icon: {
			initials: 'MP',
			color: 'bgBrand',
			textColor: 'textDefault',
		},
	},
	{
		id: `${process.env.REACT_APP_MONTEL_VALUE_APPLICATION_ID?.toLowerCase()}`,
		name: ProductName.MontelValue,
		hasPermissions: false,
		icon: {
			initials: 'MV',
			color: 'bgBrand',
			textColor: 'textDefault',
		},
	},
];

export const getProductConfig = (productId?: string) =>
	productId ? productMap.find((p) => p.id === productId.toLowerCase()) : null;

export const getProductConfigByName = (productName: ProductName) => {
	const map = productMap.find((p) => p.name === productName);

	return map;
};

export const getProductName = (productId: string) =>
	productMap.find((p) => p.id === productId.toLowerCase())?.name ?? 'N/A';
